import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=5ebc31ce&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Alert.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Alert.vue
// module id = 1697
// module chunks = 1